/**
 * TELUS Professional Installation (TPI) seat-threshold rules (spec 034).
 * Pure module: no React, network or locale-file imports.
 */

// Orders below this many total seats (Starter + Office) are "small" TPI orders.
export const TPI_SMALL_ORDER_SEAT_LIMIT = 16;

const toCount = value => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
};

export const getTpiTotalSeats = (starterSeats, officeSeats) =>
  toCount(starterSeats) + toCount(officeSeats);

export const isTpiSmallOrder = totalSeats =>
  toCount(totalSeats) < TPI_SMALL_ORDER_SEAT_LIMIT;

/**
 * Approval code (marketing approval, NBD technician, $240/seat) is required only
 * for TPI orders under 16 seats where no Dealer Tech has been arranged.
 */
export const isTpiApprovalRequired = ({
  isProfessionalInstallation,
  dealerTechAnswer,
  noValue,
  totalSeats
}) =>
  !!isProfessionalInstallation &&
  !!noValue &&
  dealerTechAnswer === noValue &&
  isTpiSmallOrder(totalSeats);

/**
 * Dealer Billed Direct is available to every channel and segment, except when
 * the approval code is required (an NBD technician performs the install).
 */
export const filterTpiPaymentOptions = (
  options,
  { approvalRequired, valueDealerBilledDirect }
) =>
  (options || []).filter(
    option =>
      !approvalRequired ||
      !option ||
      !option.fields ||
      option.fields.value !== valueDealerBilledDirect
  );
